const prefix = "chatredapp_kc_"

export const SECURITY_LEVEL = { ANY: "ANY" }
export const ACCESSIBLE = { WHEN_UNLOCKED: "WHEN_UNLOCKED" }

export const setGenericPassword = async (
  username: string,
  password: string,
  options?: { service?: string },
) => {
  localStorage.setItem(`${prefix}${options?.service ?? "default"}`, JSON.stringify({ username, password }))
  return true
}

export const getGenericPassword = async (options?: { service?: string }) => {
  const raw = localStorage.getItem(`${prefix}${options?.service ?? "default"}`)
  if (!raw) return false
  try {
    const parsed = JSON.parse(raw)
    return { username: parsed.username ?? "", password: parsed.password ?? "", service: options?.service ?? "", storage: "local" }
  } catch {
    return false
  }
}

export const resetGenericPassword = async (options?: { service?: string }) => {
  localStorage.removeItem(`${prefix}${options?.service ?? "default"}`)
  return true
}
